import { useRedux } from "hooks";
import { MemberRole, TaskStatus, WpPostInfo, WpPostInfoTag, WpSliceData } from "./redux/workplace/wpTypes";
import { createSelector } from "reselect";
import AsyncSelect from "react-select/async";
import ReactDOM from "react-dom";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { TABS, WpModes } from "./constants";
import { APIClient } from "api/apiCore";
import * as url from "api/urls"
import { backdropStyle, modalStyle } from "DialogProviderShare";
import TaskFormField, { } from "./pages/Dashboard/Workplace/TaskFormField";
import { Utils } from "helpers/utils";
import { debounce } from "lodash";
import ReactQuill from "react-quill";
import { DropdownOption, TaskRecurance2Data, TaskFormFieldData, TaskRecurance2DataDef, tb_User } from "types";
import { RecuranceModes } from "const";
import SelectDropdownAsyncWpTags from "components/SelectDropdownAsyncWpTags";
import AppSimpleBar from "components/AppSimpleBar";
import { FormControlLabel, Switch } from "@mui/material";
import Loader from "components/Loader";
import { UserTypes } from "api";
import TextBox from "components/TextBox";
import * as urls from "api/urls";
import SelectDropdown from "components/SelectDropdown";
import CreatableSelect from 'react-select/creatable';
import { useSyncCustomOption } from "helpers/common";

export function DialogProviderUserInfoPortal({ userId, allowEdit, userType, onClose }: { userId: number | null, allowEdit: boolean, userType: UserTypes, onClose: (v: any) => void }) {
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state: any) => state.WpSlice,
    (state: any) => state.Profile2,
    (wp: WpSliceData, p2: any) => ({
      // activePostInfo: wp.activePostInfo,
      curUserId: p2.userId,
      isAdmin: p2.isAdmin,
      activePost: wp.activePostInfo,
    })
  );

  const { /*activePostInfo,*/ curUserId, isAdmin, activePost } = useAppSelector(storeData);
  const [userData, setUserData] = useState<tb_User>({
    userType: userType
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [ddlCompany, setDdlCompany] = useState<any[]>([]);
  const [ddlDivision, setDdlDivision] = useState<any[]>([]);
  const [ddlDepartment, setDdlDepartment] = useState<any[]>([]);
  const [ddlPosition, setDdlPosition] = useState<any[]>([]);

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER, { groupBy: "Company" })
        .then(rs => setDdlCompany(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER, { groupBy: "Division" })
        .then(rs => setDdlDivision(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER, { groupBy: "Department" })
        .then(rs => setDdlDepartment(rs));
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => {
    try {
      new APIClient().fnPostForm(urls.WP_GET_DLL_VALUE_EXTERNAL_USER_FILTER, { groupBy: "Position" })
        .then(rs => setDdlPosition(rs));
    } catch (e) { console.error(e); }
  }, []);


  useEffect(() => {
    try {
      if (userId && userId > 0) {
        setIsLoading(true);
        new APIClient().fnPostForm(url.LOAD_USER_FOR_EDIT_2, { userId: userId, userType: userType })
          .then(rs => {
            // console.log('LOAD_USER_FOR_EDIT_2:', rs);
            if (rs?.userId) {
              setUserData(rs);
            } else {
              alert('Not found user');
              onClose(null);
            }

            setIsLoading(false);
          })
          .catch(e2 => {
            Utils.HandleException(e2, true);
            setIsLoading(false);
          });
      }
    } catch (e) {
      Utils.HandleException(e, true);
    }
  }, [userId]);

  const onUserFieldChanged = useCallback(
    (key: keyof tb_User, value: any) => {
      setUserData((prev: tb_User) => {
        const updated = { ...prev, [key]: value };
        return updated;
      });
    }, []
  );

  let errMsg = "";
  const err = (msg?: string): tb_User | null => {
    alert(msg ?? errMsg);
    return null;
  }

  const getDataForSave = () => {
    const data = { ...userData };
    if (!data.firstName) return err('กรุณาระชุชื่อ');
    if (!data.lastName) return err('กรุณาระบุนามสกุล');
    if (!data.nickName) return err('กรุณาระบุชื่อเล่น');
    if (!data.authMobileNo) return err('กรุณาระบุเบอร์มือถือ');
    if (data.authMobileNo.length != 10) return err('เบอร์มือถือต้องยาว 10 ตัวอักษร');
    if (Utils.IsNumeric(data.authMobileNo) == false) return err('เบอร์มือถือต้องเป็นตัวเลข');
    if (data.companyName == NEW_OPTION) data.companyName = ddlCompany.find(x => x.value == NEW_OPTION)?.label;
    if (data.divisionName == NEW_OPTION) data.divisionName = ddlDivision.find(x => x.value == NEW_OPTION)?.label;
    if (data.departmentName == NEW_OPTION) data.departmentName = ddlDepartment.find(x => x.value == NEW_OPTION)?.label;
    if (data.positionName == NEW_OPTION) data.positionName = ddlPosition.find(x => x.value == NEW_OPTION)?.label;
    if (!data.companyName) return err('กรุณาระบุบริษัท');

    return data;
  }

  const onSave = async () => {
    try {
      const data = getDataForSave();
      // console.log('data:', data);
      if (!data) return;

      setIsLoading(true);
      new APIClient().fnPostBody(url.SAVE_USER_EXTERNAL, data)
        .then(rs => {
          const serviceResponse = rs;
          // console.log('rs:', rs);
          if (serviceResponse.success) {
            onClose(serviceResponse.data.userId);
          } else {
            alert(serviceResponse.message);
          }

          // setTaskDataFromApi(rs, false);
          setIsLoading(false);
          // onClose( toSave2.taskId/* postId2Save*/);
        })
        .catch(ex => {
          Utils.HandleException(ex, true);
          setIsLoading(false);
        })
    } catch (e) {
      Utils.HandleException(e, true);
      setIsLoading(false);
    }
  }


  const fnDel = async () => {
    const rs = await Utils.SweetConfirm("ยืนยันการลบ");
    if (rs.isConfirmed) {
      setIsLoading(true);
      new APIClient().fnPostForm(url.DELETE_USER_EXTERNAL, { userId: userId })
        .then(rs => {
          setIsLoading(false);
          onClose(null);
        })
        .catch(er => {
          setIsLoading(false);
          Utils.HandleException(er, true);
        });
    }
  }

  // Inside your component:
  const handleEsc = useCallback((event: any) => {
    if (event.key === "Escape") {
      onClose(null);
    }
  }, [onClose]);

  useEffect(() => {
    // Add listener when the modal mounts
    window.addEventListener("keydown", handleEsc);

    // Clean up listener when the modal unmounts
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [handleEsc]);

  const fnGetCaption = () => {
    const userTypeText = Utils.GetUserTypeText(userType);
    if (userId == null) {
      return "เพิ่ม " + userTypeText;
    } else {
      return "แก้ไข " + userTypeText;
    }
  }

  const NEW_OPTION = "--new--";
  const [customCompany, setCustomCompany] = useState<string | null>(null);
  const [customDivision, setCustomDivision] = useState<string | null>(null);
  const [customDepartment, setCustomDepartment] = useState<string | null>(null);
  const [customPosition, setCustomPosition] = useState<string | null>(null);

  useSyncCustomOption(customCompany, setDdlCompany, ddlCompany, NEW_OPTION);
  useSyncCustomOption(customDivision, setDdlDivision, ddlDivision, NEW_OPTION);
  useSyncCustomOption(customDepartment, setDdlDepartment, ddlDepartment, NEW_OPTION);
  useSyncCustomOption(customPosition, setDdlPosition, ddlPosition, NEW_OPTION);

  return ReactDOM.createPortal(
    <div style={backdropStyle} >
      {isLoading && (<Loader />)}
      <div style={modalStyle} >
        <h4 className="text-primary" style={{ borderBottom: "dashed 1px var(--m2-line-divider-color)" }}>{fnGetCaption()}</h4>
        <AppSimpleBar style={{ maxHeight: "calc(100vh - 80px)", overflowX: "hidden", overflowY: "auto" }}>
          <div className="row">
            <div className="col">
              ชื่อ
              <TextBox value={userData.firstName ?? ""} onChange={(e) => onUserFieldChanged("firstName", e.target.value)} />
            </div>
            <div className="col">
              นามสกุล
              <TextBox value={userData.lastName ?? ""} onChange={(e) => onUserFieldChanged("lastName", e.target.value)} />
            </div>
            <div className="col">
              ชื่อเล่น
              <TextBox value={userData.nickName ?? ""} onChange={(e) => onUserFieldChanged("nickName", e.target.value)} />
            </div>
          </div>
          <div className="row">
            <div className="col">
              มือถือ
              <TextBox value={userData.authMobileNo ?? ""} onChange={(e) => onUserFieldChanged("authMobileNo", e.target.value)} />
            </div>
            <div className="col">
              อีเมล์
              <TextBox value={userData.email ?? ""} onChange={(e) => onUserFieldChanged("email", e.target.value)} />
            </div>
            <div className="col">
              ตำแหน่ง
              <SelectDropdown
                isDisabled={false}
                list={ddlPosition}
                selectedValue={ddlPosition.find(x => x.value == userData.positionName)}
                onValueChanged={(e) => { onUserFieldChanged("positionName", e) }}
                onInputChanged={(e) => { setCustomPosition(e) }}
                placeholder={"ตำแหน่ง"}
                isMulti={false}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              บริษัท

              <SelectDropdown
                isDisabled={false}
                list={ddlCompany}
                selectedValue={ddlCompany.find(x => x.value == userData.companyName)}
                onValueChanged={(e) => { onUserFieldChanged("companyName", e) }}
                onInputChanged={(e) => { setCustomCompany(e) }}
                placeholder={"บริษัท"}
                isMulti={false}
              />
            </div>
            <div className="col">
              หน่วยงาน
              <SelectDropdown
                isDisabled={false}
                list={ddlDivision}
                selectedValue={ddlDivision.find(x => x.value == userData.divisionName)}
                onValueChanged={(e) => { onUserFieldChanged("divisionName", e) }}
                onInputChanged={(e) => { setCustomDivision(e) }}
                placeholder={"หน่วยงาน"}
                isMulti={false}
              />
            </div>
            <div className="col">
              แผนก
              <SelectDropdown
                isDisabled={false}
                list={ddlDepartment}
                selectedValue={ddlDepartment.find(x => x.value == userData.departmentName)}
                onValueChanged={(e) => { onUserFieldChanged("departmentName", e) }}
                onInputChanged={(e) => { setCustomDepartment(e) }}
                placeholder={"แผนก"}
                isMulti={false}
              />
            </div>
          </div>
        </AppSimpleBar>
        {!isLoading && (
          <div className="mt-1 pt-1" style={{ display: "flex", justifyContent: "space-between", gap: 8, borderTop: "dashed 1px var(--m2-line-divider-color)" }}>
            <div>
              {userId && (<button className="btn btn-danger" onClick={fnDel} >ลบ</button>)}
            </div>
            <div className="d-flex justify-content-between" style={{ gap: "6px" }}>
              <button className="btn btn-warning" onClick={() => onClose(-1)} >ปิด</button>
              <button className="btn btn-primary" onClick={() => onSave()} >บันทึก</button>
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}